import '@swc/helpers/esm/_to_consumable_array.js';

/**
 * Logs a warning when this function is called, in development environment only.
 */ var deprecate = function deprecate(fn, // @ts-ignore this parameter is used in the false branch
// eslint-disable-next-line no-unused-vars
message) {
    return fn;
};

export { deprecate };
